import { Routes, Route } from "react-router-dom";

import VehicleListScreen from "screens/App/CRM/Vehicle/VehicleListScreen";
import VehicleInfoScreen from "screens/App/CRM/Vehicle/VehicleInfoScreen";
import VehicleDetailScreen from "screens/App/CRM/Vehicle/VehicleDetailScreen";
import VehicleEditScreen from "screens/App/CRM/Vehicle/VehicleEditScreen";
import VehicleCreateScreen from "screens/App/CRM/Vehicle/VehicleCreateScreen";
import VehicleInsuranceListScreen from "screens/App/CRM/Vehicle/vehicleComponents/VehicleInsuranceListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";
import LoadingShipmentDetailView from "screens/App/CRM/ShipmentLoading/ShipmentLoadingComponents/LoadingShipmentDetailView";

const VehicleRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<VehicleListScreen />} />
      <Route path="create" element={<VehicleCreateScreen />} />
      <Route path="vehicleInsurance" element={<VehicleInsuranceListScreen />} />
      <Route path=":id/detail" element={<VehicleDetailScreen />} />
      <Route
        path=":id/shipment-detail-by-vehicle"
        element={<LoadingShipmentDetailView />}
      />
      <Route path=":id/edit" element={<VehicleEditScreen />} />
      <Route path="info" element={<VehicleInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VehicleRouter;
